import isNull from 'lodash-es/isNull';
import { Observable } from 'rxjs';
import { createConnectingService } from '../base/connectingService';
import { ElementService } from '../dom/elementService';
import { NULL_SELECTION_SERVICE, SelectionService } from '../dom/selectionService';

type InputElement = HTMLTextAreaElement | HTMLInputElement;

export function createInputSelectionService(element$: Observable<InputElement | null>): SelectionService {
  return createConnectingService(
    element$,
    () => NULL_SELECTION_SERVICE,
    element => new InputSelectionService(element),
  );
}

export class InputSelectionService extends ElementService<InputElement> implements SelectionService {
  get isActive() {
    return Boolean(this.element.ownerDocument && this.element.ownerDocument.activeElement === this.element);
  }

  get selectedText() {
    const { value, selectionStart, selectionEnd } = this.element;
    if (isNull(selectionStart) || isNull(selectionEnd)) {
      return '';
    }

    return value.substring(selectionStart, selectionEnd);
  }

  moveToEnd() {
    const { element } = this;
    const endIndex = element.value.length;
    element.setSelectionRange(endIndex, endIndex);
  }

  selectAll() {
    const { element } = this;
    const endIndex = element.value.length;
    element.setSelectionRange(0, endIndex);
  }

  deselect() {
    this.moveToEnd();
  }
}
